import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as analytics from '../../services/analytics';

const FilterSelector = props => {
    const navigate = useNavigate();

    const handleClick = (adviceArea, label, key) => {
        analytics.track('Clicked Need Button', {
            category: 'Landing Page',
            label: label,
        });

        navigate('match', { state: { adviceArea: adviceArea, label: label, key: key } });
    };

    const renderAllFilters = className => {
        if (!props.filters || !props.filters.count()) {
            return '';
        }

        const filters = [];

        props.filters.forEach((filter, key) => {
            const selectedClass = filter.get('selected') ? 'selected' : '';

            filters.push(
                <div
                    className={`${className}__filter ${selectedClass} app__grid__column__three-two-one`}
                    key={key}
                    onClick={() => handleClick(filter.get('id'), filter.get('label'), key)}>
                    <div dangerouslySetInnerHTML={{ __html: filter.get('name') }}></div>
                </div>
            );
        });

        return filters;
    };

    const className = props.className ? props.className : 'app__filter-selector';

    return <div className={className}>{renderAllFilters(className)}</div>;
};

export default FilterSelector;
